<mbs-wizard
  class="mbs-wizard_flex-content"
  [buttonLoadingMode]="true"
  [cancelButton]="{ hide: false, text: 'shared:buttons.cancel' | i18next }"
  [canClosed]="!loadingPlan && wizardFinish"
  [firstStepTitle]="mainService.firstStepTitle"
  [ignoreSteps]="ignorableSteps"
  [isOpenSteps]="!loadingPlan && (isEdit || stepsManager.allStepsVisited)"
  [loading]="loadingPlan"
  [saveButton]="{ text: 'shared:buttons.save' | i18next }"
  [scrollableStepContent]="true"
  [stepQueue]="stepsManager.stepQueue"
  [stepsContainerClass]="mainService.isOffline ? 'overflow-hidden' : ''"
  [stepsOrientation]="orientations"
  [title]="wizardTitle + ' ' + mainService.compName + ' | ' + (FormModel?.planNameStep?.Name || '')"
  [(ngModel)]="stepsManager.currentStep"
  (closeModalEvent)="handleModalClose()"
  (next)="nextHandler($event)"
  (save)="handleSave()"
  (stepSelected)="stepSelectedHandler($event)">
  @if (mainService.isOffline) {
    <div
      class="pl-4 py-2 background-secondary"
      prependStep>
      <span class="fa fa-power-off"></span> {{ prependStepText }}
    </div>
  }
  <mbs-wizard-step
    [documentationLink]="helpLink.links.welcome"
    [title]="'wizards:welcome' | i18next"
    [valid]="FormModel?.planNameStep?.valid"
    (next)="planNameStep?.forceValid()">
    <mbs-plan-name-step
      #planNameStep
      [planTypeText]="planTypeText"
      [(ngModel)]="FormModel.planNameStep"
      (copyPlan)="handleCopyRAWPlan()"></mbs-plan-name-step>
  </mbs-wizard-step>
  @if (ABTest.DestinationPlusRetentionStep) {
    <mbs-wizard-step
      [documentationLink]="helpLink.links.destinationPlusRetention"
      [title]="'wizards:whereBackup.where_backup_step_title' | i18next"
      [valid]="combinedDataManager.whereBackupPlusRetention?.valid"
      (next)="destinationPlusRetentionStep?.forceValid()">
      <mbs-destination-plus-retention-step
        #destinationPlusRetentionStep
        [advancedOptionsAvailable]="isNBF || storageManager.selectedStorageAmazonOrAzure"
        [advancedOptionsTitle]="stepsManager.titles.advancedSettings"
        [advancedOptionsValid]="FormModel?.advancedSettingsStep?.valid"
        [scheduleTitle]="stepsManager.titles.schedule"
        [Storages]="FormModel?.Storages"
        [(ngModel)]="combinedDataManager.whereBackupPlusRetention"
        (advancedOptionsOpened)="advancedSettingsStep.stepFocused = $event"
        (changeStorage)="changeHyperVStorageHandler($event)"
        (registerRequiredStep)="stepsManager.stepQueue.registerRequiredStep($event)">
        <mbs-advanced-settings-virtual-step
          #advancedSettingsStep
          [advancedOptionsFlags]="FormModel?.advancedOptionsFlags"
          [selectedStorage]="storageManager.selectedStorage"
          [(ngModel)]="FormModel.advancedSettingsStep"
          (changeStorageType)="storageManager.changeAdvancedStorageHandler($event)"></mbs-advanced-settings-virtual-step>
      </mbs-destination-plus-retention-step>
    </mbs-wizard-step>
  } @else {
    <mbs-wizard-step
      [documentationLink]="helpLink.links.whereToBackUp"
      [title]="'wizards:whereBackup.where_backup_step_title' | i18next"
      [valid]="FormModel?.whereBackupStep?.valid"
      (next)="whereBackupStep?.forceValid()">
      <mbs-where-backup-step
        #whereBackupStep
        [Storages]="FormModel?.Storages"
        [(ngModel)]="FormModel.whereBackupStep"
        (changeStorage)="changeHyperVStorageHandler($event)"></mbs-where-backup-step>
    </mbs-wizard-step>
  }

  @if (canShowClusterStep) {
    <mbs-wizard-step
      [documentationLink]="helpLink.links.cluster"
      [title]="clusterTitle"
      [valid]="FormModel?.clusterStep?.valid"
      (next)="clusterStep?.forceValid(stepsManager.currentStep)">
      <mbs-cluster-step
        #clusterStep
        [(ngModel)]="FormModel.clusterStep"
        (loadInfo)="loadInfoHandler($event)"
        (nextStep)="forceNextStepWizard(!!$event, 'clusterStep', clusterTitle)"></mbs-cluster-step>
    </mbs-wizard-step>
  }

  <mbs-wizard-step
    [documentationLink]="helpLink.links.whatToBackUp"
    [title]="selectVMTitle"
    [valid]="FormModel?.selectVirtualMachinesStep?.valid"
    (next)="selectVirtualMachinesStep?.forceValid(stepsManager.currentStep)">
    <mbs-select-virtual-machines-step
      #selectVirtualMachinesStep
      [cluster]="FormModel?.clusterStep"
      [title]="selectVMTitle"
      [(ngModel)]="FormModel.selectVirtualMachinesStep"
      (loadInfo)="loadInfoHandler($event)"
      (machinesSelected)="machinesSelectedHandler($event)"
      (nextStep)="forceNextStepWizard(!!$event, 'selectVirtualMachinesStep', selectVMTitle)"
      (registerRequiredStep)="stepsManager.stepQueue.registerRequiredStep($event)"></mbs-select-virtual-machines-step>
  </mbs-wizard-step>
  @if (isNBF && canShowAppAwareStep) {
    <mbs-wizard-step
      [documentationLink]="helpLink.links.applicationProcessing"
      [title]="'wizards:appAwareTitle' | i18next"
      [valid]="FormModel?.appAwareStep.valid"
      (next)="appAwareStep?.forceValid(stepsManager.currentStep)">
      <mbs-app-aware-step
        #appAwareStep
        [selectedMachines]="selectedMachines"
        [(ngModel)]="FormModel.appAwareStep"
        (loadInfo)="loadInfoHandler($event)"></mbs-app-aware-step>
    </mbs-wizard-step>
  }

  @if (!ABTest.DestinationPlusRetentionStep && (isNBF || storageManager.selectedStorageAmazonOrAzure)) {
    <mbs-wizard-step
      [documentationLink]="helpLink.links.advancedSettings"
      [title]="stepsManager.titles.advancedSettings"
      [valid]="FormModel?.advancedSettingsStep?.valid"
      (next)="advancedSettingsStep?.forceValid(stepsManager.currentStep)">
      <mbs-advanced-settings-virtual-step
        #advancedSettingsStep
        [advancedOptionsFlags]="FormModel?.advancedOptionsFlags"
        [selectedStorage]="storageManager.selectedStorage"
        [stepFocused]="stepsManager.currentStep?.title === stepsManager.titles.advancedSettings"
        [(ngModel)]="FormModel.advancedSettingsStep"
        (changeStorageType)="storageManager.changeAdvancedStorageHandler($event)"
        (nextStep)="
          forceNextStepWizard(!!$event, 'advancedSettingsStep', stepsManager.titles.advancedSettings)
        "></mbs-advanced-settings-virtual-step>
    </mbs-wizard-step>
  }

  @if (canShowSelectVirtualDiskStep) {
    <mbs-wizard-step
      [documentationLink]="helpLink.links.selectVirtualDisks"
      [title]="'wizards:select_virtual_disks_title' | i18next"
      [valid]="FormModel?.selectVirtualDisksStep?.valid"
      (next)="selectVirtualDisksStep?.forceValid()">
      <mbs-select-virtual-disks-step
        #selectVirtualDisksStep
        [selectedMachinesStepValue]="FormModel?.selectVirtualMachinesStep"
        [(ngModel)]="FormModel.selectVirtualDisksStep"
        (loadInfo)="loadInfoHandler($event)"></mbs-select-virtual-disks-step>
    </mbs-wizard-step>
  }
  <mbs-wizard-step
    [documentationLink]="helpLink.links.compressionEncryption"
    [title]="stepsManager.titles.compressionEncryption"
    [valid]="FormModel?.compressionEncryptionStep?.valid"
    (next)="compressionEncryptionStep?.forceValid(stepsManager.currentStep)">
    <mbs-compression-encryption-step
      #compressionEncryptionStep
      [isS3Selected]="storageManager.useS3AccelerationPossible"
      [loadingPlan]="loadingPlan"
      [stepFocused]="stepsManager.currentStep?.title === stepsManager.titles.compressionEncryption"
      [(ngModel)]="FormModel.compressionEncryptionStep"
      (nextStep)="forceNextStepWizard(!!$event, 'compressionEncryptionStep', 'Compression & Encryption')"></mbs-compression-encryption-step>
  </mbs-wizard-step>
  @if (isNBF) {
    <mbs-wizard-step
      [documentationLink]="helpLink.links.backupConsistencyCheck"
      [title]="'wizards:archive_consistency_backup_title' | i18next"
      [valid]="FormModel?.archiveConsistencyStep?.valid"
      (next)="archiveConsistencyStep?.forceValid()">
      <mbs-consistency-step
        #archiveConsistencyStep
        [(ngModel)]="FormModel.archiveConsistencyStep"
        (loadInfo)="loadInfoHandler($event)"></mbs-consistency-step>
    </mbs-wizard-step>
  }
  <!-- New Schedule and Retention steps  -->
  @if (isNBF) {
    @if (stepsManager.useNewSchedule) {
      <mbs-wizard-step
        [documentationLink]="helpLink.links.schedule"
        [title]="stepsManager.titles.schedule"
        [valid]="FormModel?.scheduleStep?.valid"
        (next)="scheduleStepNBF?.forceValid(stepsManager.currentStep)">
        <mbs-nbf-schedule-step
          #scheduleStepNBF
          [retentionTitle]="stepsManager.titles.retention"
          [stepFocused]="stepsManager.currentStep?.title === stepsManager.titles.schedule"
          [title]="stepsManager.titles.schedule"
          [(ngModel)]="FormModel.scheduleStep"
          (changeType)="scheduleTypeChangeHandler($event)"
          (nextStep)="forceNextStepWizard(!!$event, 'scheduleStep', stepsManager.titles.schedule)"
          (selectStep)="stepsManager.setCurrentStep($event)"></mbs-nbf-schedule-step>
      </mbs-wizard-step>
    } @else {
      <mbs-wizard-step
        [documentationLink]="helpLink.links.schedule"
        [title]="stepsManager.titles.schedule"
        [valid]="FormModel?.scheduleStep?.valid"
        (next)="scheduleStep?.forceValid(stepsManager.currentStep)">
        <mbs-schedule-step
          #scheduleStep
          [isGFSMode]="isGFSMode"
          [retentionTitle]="stepsManager.titles.retention"
          [retentionUseDefault]="FormModel.retentionPolicyStep.RetentionUseDefaultSettings"
          [stepFocused]="stepsManager.currentStep?.title === stepsManager.titles.schedule"
          [(ngModel)]="FormModel.scheduleStep"
          (changeType)="scheduleTypeChangeHandler($event)"
          (incrementalData)="setIncrementalData($event)"
          (nextStep)="forceNextStepWizard(!!$event, 'scheduleStep', stepsManager.titles.schedule)"
          (registerRequiredStep)="stepsManager.stepQueue.registerRequiredStep($event)"
          (selectStep)="stepsManager.setCurrentStep($event)"
          (unregisterRequiredStep)="stepsManager.stepQueue.unregisterRequiredStep($event)"></mbs-schedule-step>
      </mbs-wizard-step>
    }
    @if (!ABTest.DestinationPlusRetentionStep) {
      @if (stepsManager.useNewRetention) {
        <mbs-wizard-step
          [documentationLink]="helpLink.links.retention"
          [title]="stepsManager.titles.retention"
          [valid]="FormModel?.retentionPolicyStep?.valid"
          (next)="retentionPolicyStep?.forceValid(stepsManager.currentStep)">
          <mbs-nbf-retention-policy-step
            #retentionPolicyStep
            [isHybrid]="FormModel.whereBackupStep.IsHybridBackup"
            [stepFocused]="stepsManager.currentStep?.title === stepsManager.titles.retention"
            [(ngModel)]="FormModel.retentionPolicyStep"
            (backStep)="forceBackStepWizard('retentionPolicyStep', stepsManager.titles.retention)"
            (nextStep)="
              forceNextStepWizard(!!$event, 'retentionPolicyStep', stepsManager.titles.retention)
            "></mbs-nbf-retention-policy-step>
        </mbs-wizard-step>
      } @else {
        <mbs-wizard-step
          [documentationLink]="helpLink.links.retention"
          [title]="stepsManager.titles.retention"
          [valid]="FormModel?.retentionPolicyStep?.valid"
          (next)="retentionPolicyStep?.forceValid(stepsManager.currentStep)">
          <mbs-retention-policy-step
            #retentionPolicyStep
            [incrementalScheduleData]="incrementalData"
            [isFullBackup]="FormModel?.scheduleStep?.fullBackupData?.enabled"
            [isHybrid]="FormModel.whereBackupStep.IsHybridBackup"
            [isMonthly]="FormModel?.scheduleStep?.fullBackupData?.recurringPeriod === 'Monthly'"
            [minPeriod]="storageManager.minPeriod"
            [showIntelligentRetention]="!invalidIntelligentRetentionStorage"
            [stepFocused]="stepsManager.currentStep?.title === stepsManager.titles.retention"
            [(ngModel)]="FormModel.retentionPolicyStep"
            (backStep)="forceBackStepWizard('retentionPolicyStep', stepsManager.titles.retention)"
            (nextStep)="forceNextStepWizard(!!$event, 'retentionPolicyStep', stepsManager.titles.retention)"></mbs-retention-policy-step>
        </mbs-wizard-step>
      }
    }
  }

  @if (!isNBF) {
    <mbs-wizard-step
      [documentationLink]="helpLink.links.retention"
      [title]="stepsManager.titles.retention"
      [valid]="FormModel?.retentionPolicyStep?.valid"
      (next)="retentionPolicyStep?.forceValid()">
      <mbs-retention-policy-step
        #retentionPolicyStep
        [incrementalScheduleData]="incrementalData"
        [isHybrid]="FormModel.whereBackupStep.IsHybridBackup"
        [minPeriod]="storageManager.minPeriod"
        [(ngModel)]="FormModel.retentionPolicyStep"></mbs-retention-policy-step>
    </mbs-wizard-step>

    <mbs-wizard-step
      [documentationLink]="helpLink.links.schedule"
      [title]="stepsManager.titles.schedule"
      [valid]="FormModel?.scheduleStep?.valid"
      (next)="scheduleStep?.forceValid(stepsManager.currentStep)">
      <mbs-schedule-step
        #scheduleStep
        [isGFSMode]="isGFSMode"
        [retentionTitle]="stepsManager.titles.retention"
        [retentionUseDefault]="FormModel.retentionPolicyStep.RetentionUseDefaultSettings"
        [stepFocused]="stepsManager.currentStep?.title === stepsManager.titles.schedule"
        [(ngModel)]="FormModel.scheduleStep"
        (changeType)="scheduleTypeChangeHandler($event)"
        (incrementalData)="setIncrementalData($event)"
        (nextStep)="forceNextStepWizard(!!$event, 'scheduleStep', stepsManager.titles.schedule)"
        (registerRequiredStep)="stepsManager.stepQueue.registerRequiredStep($event)"
        (selectStep)="stepsManager.setCurrentStep($event)"
        (unregisterRequiredStep)="stepsManager.stepQueue.unregisterRequiredStep($event)"></mbs-schedule-step>
    </mbs-wizard-step>

    @if (FormModel?.scheduleStep?.ScheduleType === 'recurring') {
      <mbs-wizard-step
        [title]="'wizards:advanced_schedule_step_title' | i18next"
        [valid]="FormModel?.scheduleAdvancedStep?.valid"
        (next)="scheduleAdvancedStep?.forceValid()">
        <mbs-schedule-advanced-step
          #scheduleAdvancedStep
          [(ngModel)]="FormModel.scheduleAdvancedStep"></mbs-schedule-advanced-step>
      </mbs-wizard-step>
    }

    @if (FormModel?.scheduleStep?.ScheduleType === 'predefined') {
      <mbs-wizard-step
        [title]="'wizards:simple_schedule_title' | i18next"
        [valid]="FormModel?.simpleScheduleStep?.valid"
        (next)="simpleScheduleStep?.forceValid()">
        <mbs-simple-schedule-step
          #simpleScheduleStep
          [(ngModel)]="FormModel.simpleScheduleStep"></mbs-simple-schedule-step>
      </mbs-wizard-step>
    }
  }

  <mbs-wizard-step
    [documentationLink]="helpLink.links.prePost"
    [title]="
      (mainService.allowPrePostActions | async) ? ('wizards:pre_post_title' | i18next) : ('wizards:pre_post_title_backup_chain' | i18next)
    "
    [valid]="FormModel?.prePostActionsStep?.valid"
    (next)="prePostActionsStep?.forceValid()">
    <mbs-pre-post-actions-step
      #prePostActionsStep
      [ChainPlans]="FormModel?.AvailableMachinePlans"
      [(ngModel)]="FormModel.prePostActionsStep"></mbs-pre-post-actions-step>
  </mbs-wizard-step>
  @if (!isRDMode) {
    <mbs-wizard-step
      [documentationLink]="helpLink.links.notification"
      [title]="'wizards:notification_step_title' | i18next"
      [valid]="FormModel?.notificationStep?.valid">
      <mbs-notifications-step
        [notification]="mainService.planNotification"
        [(ngModel)]="FormModel.notificationStep"
        (notificationChange)="notificationChangeHandler($event)"></mbs-notifications-step>
    </mbs-wizard-step>
  }
</mbs-wizard>
